define('responsive-game-feed/app/scripts/views/Feed',['require','exports','module','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','../views/Video','../views/Social','../views/GameOver','../utils/Utils','../utils/logger','../views/PlayByPlay','../views/Inning','../views/DataViz','../views/Scout','text!colorFeedTemplate/Video.mustache','text!colorFeedTemplate/Social.mustache','text!colorFeedTemplate/PlayByPlay.mustache','text!colorFeedTemplate/Inning.mustache','text!colorFeedTemplate/DataViz.mustache','text!colorFeedTemplate/Scout.mustache','text!colorFeedTemplate/GameOver.mustache','image-monitor/image-monitor'],function(require, exports, module) {

    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var VideoView = require("../views/Video");
    var SocialView = require("../views/Social");
    var GameOverView = require("../views/GameOver");
    var Utils = require("../utils/Utils");
    var logg  = require( "../utils/logger" );
    var PlayByPlayView  = require("../views/PlayByPlay");
    var InningView  = require("../views/Inning");
    var DataVizView  = require("../views/DataViz");
    var ScoutView  = require("../views/Scout");
    var videoText = require('text!colorFeedTemplate/Video.mustache');
    var socialText = require('text!colorFeedTemplate/Social.mustache');
    var playByPlayText = require('text!colorFeedTemplate/PlayByPlay.mustache');
    var inningText = require('text!colorFeedTemplate/Inning.mustache');
    var datavizText = require('text!colorFeedTemplate/DataViz.mustache');
    var scoutText = require('text!colorFeedTemplate/Scout.mustache');
    var gameOverText = require('text!colorFeedTemplate/GameOver.mustache');
    var imageMonitor = require("image-monitor/image-monitor");
    
    
    
    
     
    /**
     * CLASS DESCRIPTION
     *
     * @param NAME {TYPE} PARAM DESCRIPTION
     * @return {TYPE} RETURN DESCRIPTION
     */

    function FeedView(element) {
        // var templatePath = Utils.options.templatePath;
        this.element = $("#game-feed");
        this.temp;
        this.views = {};
        // this.templateArray = ['requirejs-text/text!'+templatePath+'Video.mustache', 'requirejs-text/text!'+templatePath+'Social.mustache', 'requirejs-text/text!'+templatePath+'/PlayByPlay.mustache', 'requirejs-text/text!'+templatePath+'Inning.mustache', 'requirejs-text/text!'+templatePath+'DataViz.mustache', 'requirejs-text/text!'+templatePath+'Scout.mustache'];
        this.templates = {
          video: "",
          social:"",
          playbyplay:"",
          inning:"",
          dataViz: "",
          scout: ""
        };
        this.viewCfg = {
          element: this.element, 
          isPrepend: false
        };
        
        //init views
        this.views['video'] = new VideoView(this.viewCfg);
        this.views['social'] = new SocialView(this.viewCfg);
        this.views['playByPlay'] = new PlayByPlayView(this.viewCfg);
        this.views['inning'] = new InningView(this.viewCfg);
        this.views['dataViz'] = new DataVizView(this.viewCfg);
        this.views['scout'] = new ScoutView(this.viewCfg);
        this.views['gameOver'] = new GameOverView(this.viewCfg);
        
        
    }
    
   
    FeedView.prototype = {

        
        events: {
          EVENT_RENDER_SUCCESS : "renderSuccess"
        },
        
        /**
         * METHOD DESCRIPTION
         *
         * @param NAME {TYPE} PARAM DESCRIPTION
         * @return {TYPE} RETURN DESCRIPTION
         */
        
        getHtml: function(items,isPrepend) {
            var that = this;
            var temp = "";
            var total = items.length;
            var renderCBTracker = [];
            that.total = total;
            
            for (var i = items.length-1; i >= 0 ; i--) {
               if (items[i] && items[i].guid) {
               var tEvt = "renderCBTracker_"+items[i].guid;
               $(this).bind(tEvt, function(e,id) {
                   renderCBTracker.push(id);
                   $(that).off(tEvt);
                   
                   if (renderCBTracker.length === that.total) {
                     $(that).trigger(that.events['EVENT_RENDER_SUCCESS']);
                   }
               });
               
               var type = items[i].group;
               this.views[type].render({
                  model: items[i],
                  template: this.templates[type],
                  isPrepend: isPrepend,
                  feedView: $(that)
               });
               }
               
             if (i === items.length-1) {
               imageMonitor(true);
             }
            }
            
          
        },
        
         /**
         * METHOD DESCRIPTION
         *
         * @param NAME {TYPE} PARAM DESCRIPTION
         * @return {TYPE} RETURN DESCRIPTION
         */
         
        render: function(items, isPrepend) {
           var that = this;
           var items = items.data;
           var hasNewItems = (items.length > 0) ? true : false;
           this.viewCfg.isPrepend = isPrepend;
           
           if (this.templates.video !== "") {
             that.getHtml(items,isPrepend)
             return false;
           } socialText
           
              that.templates["video"] = videoText;
              that.templates["social"] = socialText;
              that.templates["playByPlay"] = playByPlayText;
              that.templates["inning"] = inningText;
              that.templates["dataViz"] = datavizText;
              that.templates["scout"] = scoutText;
              that.templates["gameOver"] = gameOverText;
              that.getHtml(items,isPrepend)
              
          
        }
    }

    return FeedView;
});

